import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import "moment/locale/th";
import * as userApi from "../../../service/userApi";
import { splitBirthday } from "../../../utils/utils";
import { CurrentUserContext } from "../../../App";

function LoginProviderID() {
  const { setUserRole, setIsMessage } = useContext(CurrentUserContext);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    getParameter();
  }, []);

  const getParameter = () => {
    let url = decodeURIComponent(window.location.href);
    let newUrl = new URL(url);
    let data = newUrl.searchParams;

    // role chosen on /login or /register before the redirect (NewLogin /
    // register service store it — the registered redirect_uri can't carry it)
    const role = sessionStorage.getItem("provider_id_user_type");
    sessionStorage.removeItem("provider_id_user_type");

    if (data.get("code") && role) {
      loginProviderID(data.get("code"), role);
    } else if (data.get("code")) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน แล้วเข้าสู่ระบบด้วย Provider ID อีกครั้ง",
      });
      nav("/login");
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
      nav("/login");
    }
  };

  const loginProviderID = async (code, role) => {
    setLoading(true);
    let res = await userApi.loginProviderID(code, role);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "login success" });
        logedIn(res["data"]);
      } else if (res["data"]["code"] === 404) {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || "ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน",
        });
        // backend sends the profile under mohpromt_user_data for every provider
        let data = res["data"]["mohpromt_user_data"] || {};
        nav("/register", {
          state: {
            type: "register_provider_id",
            pname: data["pname"],
            fname: data["fname"],
            lname: data["lname"],
            pid: data["pid"],
            phoneNumber: data["phone_number"],
            providerId: data["account_id"],
            registerToken: data["register_token"],
            role: data["role"],
            ...splitBirthday(data["birthday"]),
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        nav("/login");
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      nav("/login");
    }
  };

  const logedIn = (data) => {
    localStorage.setItem("pg_access_token", data["user_data"]["auth"]["access_token"]);
    localStorage.setItem("expire_login_user", data["user_data"]["auth"]["access_token_expire"]);
    localStorage.setItem("user", JSON.stringify(data["user_data"]));

    setUserRole(data["user_data"]);
    nav("/search-for-patient-information");
  };

  return (
    <div className="global-page h-[80vh]">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
    </div>
  );
}

export default LoginProviderID;
